const tables = [
  {
    name: "Number",
  },
  {
    name: "Purchase Order",
  },
  {
    name: "Supplier",
  },
  {
    name: "Date",
  },
  {
    name: "Reason",
  },
  {
    name: "Total",
  },
  {
    name: "Created By",
  },
  {
    name: "Action",
  },
];

export default tables;